<template>
    <div>
        <div v-if="active" class="event-tab">
            <div class="info wrapper dark fs-small bg-lightest px-4">

                <div class="col-sm-12 text-center mb-3" v-if="event.status == -1">
                    <div class="color-6 fs-large">Activity Canceled</div>
                    <div class="darker" v-if="event.statusMessage">{{event.statusMessage}}</div>
                </div>

                <!-- <div class="col-sm-12 text-center mb-3" v-if="!salesChannelsStatus.me">
                    <div class="color-6 fs-large"><b>SALES NOT ALLOWED</b></div>
                    <div class="darker">Booking not allowed</div>
                </div>
                <div class="col-sm-12 text-center mb-3" v-if="!salesChannelsStatus.agent">
                    <div class="color-1"><b>AGENTS SALES CLOSED</b> </div>
                    <div class="darker">Booking not allowed</div>
                </div>
                   <div class="col-sm-12 text-center mb-3" v-if="!salesChannelsStatus.widget">
                    <div class="color-3"><b>WIDGET SALES CLOSED</b></div>
                    <div class="darker">Booking not allowed</div>
                </div> -->


                <div class="d-flex">
                        <div class="detailLabel bold">
                            Departure:
                        </div>

                        <div class="darker bold p-0">
                            {{ event.start | moment('YYYY.MM.DD') }} | {{ event.start | moment('HH:mm') }}
                        </div>
                </div>

                <div class="d-flex mt-2">
                        <div class="detailLabel bold">
                            Duration:
                        </div>

                        <div class="darker bold p-0">
                            {{hourToDuration(this.event.duration)}}
                        </div>

                </div>

                <div class="d-flex mt-2" v-if="event.product && event.product.transport && event.product.transport.length > 0">
                        <div class="detailLabel bold">
                            Transport:
                        </div>

                        <div class="darker bold p-0">
                            {{ event.product.transport.name }}
                        </div>
                </div>

                <!-- <div class=" mt-2" v-if="event.eventResources.length > 0">
                    <div class="row">
                        <div class="detailLabel bold">
                            {{resourcesString}}:
                        </div>

                        <div class="darker bold p-0">
                            <div  v-for="resource in event.eventResources">
                                {{ resource.name }}
                            </div>
                        </div>
                    </div>
                </div> -->

                <div class="d-flex mt-2" v-if="event.location">
                        <div class="detailLabel bold">
                            Location:
                        </div>

                        <div class="darker bold p-0">
                            {{ event.location }}
                        </div>
                </div>

                <div class="d-flex mt-2">
                        <div class="detailLabel bold">
                            Channel:
                        </div>

                        <div class="darker bold p-0 d-flex flex-row">
                            <div class="d-flex align-items-center" v-tooltip="channelToolTips.agent">
                                <span class="channelCircle mr-1 radius-circle bg-medium" :class="{'bg-color-4': salesChannelsStatus.agentCustom,'bg-color-3':salesChannelsStatus.agent, 'bg-dark': !salesChannelsStatus.agent}"></span>
                                <span>Agents</span>
                            </div>
                            <div class="d-flex align-items-center ml-2" v-tooltip="channelToolTips.widget">
                                <span class="channelCircle mr-1 radius-circle bg-medium" :class="{'bg-color-3':salesChannelsStatus.widget, 'bg-dark': !salesChannelsStatus.widget}"></span>
                                <span>Widget</span>
                            </div>
                            <div class="d-flex align-items-center ml-2" v-tooltip="channelToolTips.me">
                                <span class="channelCircle mr-1 radius-circle bg-medium" :class="{'bg-color-3':salesChannelsStatus.me, 'bg-dark': !salesChannelsStatus.me}"></span>
                                <span>Me</span>
                            </div>
                        </div>
                </div>

            </div>

            <div class="wrapper d-flex">
                <!-- Available Card -->
                <div class="w-100 px-3 bg-lighter radius-normal border-medium py-2 mr-1 d-flex flex-column maxWidth50">

                    <div class="border-bottom-light">
                        <div class="text-uppercase fs-smallest dark">Available</div>
                        <div v-if="event.availabilityType == 1" class="fs-giant" v-tooltip="'Unlimited'">
                            <i class="fas fa-infinity"></i>
                        </div>
                        <div v-else class="fs-giant">{{event.quantityAvailable}}</div>
                        <div class=" mb-2">
                            <span v-if="totalReserved" class="lightest bg-color-1 radius-normal fs-smaller px-1 bold">{{totalReserved}} booking now</span>

                            <!-- empty space to equal the spacing -->
                            <span v-else>&nbsp;</span>
                        </div>
                    </div>

                    <div class="border-bottom-light mb-2 flexGrow1 py-1">
                        <div v-if="event.eventResources.length < 1" class="light h-100 d-flex align-items-center justify-content-center">No resources</div>
                        <div v-else class="d-flex justify-content-between fs-smaller" v-for="resource in event.eventResources">
                            <div class="dark elipsis mr-2 cursor-default text-uppercase bold" v-tooltip="resource.name">{{resource.name}}</div>
                            <div v-if="event.availabilityType == 2" class="d-flex">
                                <span class="darker bold">{{resource.capacityAvailable}}</span>
                                <span class="dark bold">/{{resource.maxSeats}}</span>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div class="d-flex justify-content-between">
                            <div class="text-uppercase fs-smaller dark bold">
                                Booked
                            </div>
                            <div class="bold">
                                {{event.quantityBooked}}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- Check-in Card -->
                <div class="w-100 px-3 bg-lighter radius-normal border-medium py-2 ml-1 d-flex flex-column maxWidth50">

                    <div class="border-bottom-light">
                        <div class="text-uppercase fs-smallest dark">Check-ins</div>
                        <div class="fs-giant">{{event.totalPAXCheckedIn}}/{{event.quantityBooked}}</div>
                        <div class="bold mb-2" :class="{'color-6':event.totalPAXMissing > 0, 'dark':event.totalPAXMissing == 0}">{{event.totalPAXMissing}} missing</div>
                    </div>

                    <div class="border-bottom-light mb-2 flexGrow1 py-1">

                        <div class="d-flex justify-content-between" v-for="clientType in event.eventOccupancyList" v-if="isToShowThisClientType(clientType)">
                            <div
                                class="dark elipsis flexGrow1 mr-2 text-uppercase bold fs-smaller"
                                v-tooltip="clientType.audienceType ? clientType.audienceTypeDescription : 'Order'">
                                    {{clientType.audienceType ? clientType.audienceTypeDescription : 'Order'}}
                            </div>

                            <div class="fs-smaller">
                                <span class="darker bold">{{clientType.quantity}}</span>
                            </div>
                        </div>

                    </div>

                    <div>
                        <div class="d-flex justify-content-between">
                            <div class="text-uppercase fs-smaller dark bold">
                                No-Shows
                            </div>
                            <div class="bold">
                                {{event.totalPAXNoShow}}
                            </div>
                        </div>
                    </div>

                </div>

                <!-- shared resources text -->
            </div>

            <div v-if="event.availabilityType == 2 && event.shareType == 1" class="wrapper mt-0 pt-0 d-flex">
                <img src="/static/images/event/shared_product_icon_black.svg" class="mr-1 p-1" :style="{'background-color': eventColor.codeSecundary}">
                <div class="fs-normal">Resource are shared with more activities</div>
            </div>


        </div>
    </div>
</template>

<script>
    import Notes from './EventNotes'
    import EventMeter from './EventMeter'
    import {mapGetters} from 'vuex'
    import { eventMixin } from '@/mixins/event'
    export default {
        props: {
            active: Boolean,
            event: Object
        },
        computed: {
            ...mapGetters([
                'account',
                'getEventColors'
            ]),
            isPerOrderWithParticipants: function () {
                let genderPricesExcludedFromBilling = this.event.eventGenderPrices.find(i => i.isExcludedFromBilling)
                if(genderPricesExcludedFromBilling){
                    return this.event.eventGenderPrices.length > 1 && genderPricesExcludedFromBilling.genderPriceType == 1
                } else {
                    return false
                }
            },
            eventColor: function() {
                let vm = this
                return this.getEventColors.filter(function(storedColor){
                    return vm.event.product.color == storedColor.id;
                })[0]
            },
            totalReserved: function () {
                return this.event.quantityReserved? this.event.quantityReserved : 0
            },
            totalCheckin: function() {
                var totalCheckin = 0;

                /*
                this.reservations.forEach((r) => {
                    totalCheckin += r.checkin;
                });
                */
                return totalCheckin;
            },
            multipleDays: function() {
                return (this.formatDate(this.event.start) != this.formatDate(this.event.end));
            },
            resourcesString: function() {
                if(this.event.product.resources){
                    return (this.event.product.resources.length > 1) ? 'Resources' : 'Resource';
                } else {
                    return 'Resource'
                }
            },
            calcQuantityAvailable: function() {
                return this.event.maximumLotation - this.event.quantityBooked
            },
            reservationHasPricePerPerson: function() {
                return this.event.eventOccupancyList.length > 0 && this.event.eventOccupancyList[0].productPriceType == 2
            },
            salesChannelsStatus: function () {
                return {
                    me: this.canISellThisEvent(this.event),
                    widget: this.canWidgetSellThisEvent(this.event),
                    agent: this.canAgentSellThisEvent(this.event),
                    agentCustom: this.canAgentCustomSellThisEvent(this.event),
                }
            },
            channelToolTips: function () {
                let textWidget = 'Channel ' + (this.salesChannelsStatus.widget? 'Open' : 'Closed')
                let textMe = 'Channel "'+ this.account.salesChannel.name+ '" is ' + (this.salesChannelsStatus.me? 'Open' : 'Closed')
                let textAgent = 'Channel '
                if(this.salesChannelsStatus.agent){
                    if(this.salesChannelsStatus.agentCustom){
                        textAgent += 'Open for some agents'
                    } else {
                        textAgent += 'Open'
                    }
                } else {
                    textAgent += 'Closed'
                }


                return {
                    me: textMe,
                    widget: textWidget,
                    agent: textAgent
                }
            }
        },
        methods: {
            isToShowThisClientType: function (clientType) {
                if(this.isPerOrderWithParticipants && clientType.audienceType === null){
                    return false
                } else {
                    return true
                }
            }
        },
        components: {
            EventMeter,
            Notes
        },
        mixins:[
            eventMixin
        ]
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .maxWidth50{
        max-width: 50%
    }

    .elipsis{
        max-width: 100%;
        overflow:hidden;
        white-space:nowrap;
        text-overflow: ellipsis;
    }

    .misc {
        > li {
            display: inline-block;
            padding: 0.25rem 0.3rem;
            border: 1px solid $light;
            background-color: $faded;
            margin: 0.5rem 0 0;
            width: calc(50% - 5px);
            border-radius: 4px;

            &:nth-child(even) {
                margin-left: 5px;
            }
        }
    }

    .channelCircle{
        width: 8px;
        height: 8px;
        display: inline-block;
    }

    .detailLabel{
        width: 80px;
    }

</style>



// WEBPACK FOOTER //
// EventDetails.vue?065ba232